import React, { useState } from "react";
import DetailPackageComponent from "../../components/DetailPackage";
import { useQuery } from "@tanstack/react-query";
import { getPackageDetail } from "../../../../../services/Handlers/MasterPackageService";
import { getParams } from "../../../../../utils/utils";
import LoadingSection from "../../../../components/LoadingSection";

export default function DetailPackage() {
  const id = getParams("id");

  const [initialValues, setInitialValues] = useState({});

  const { isLoading, isFetching } = useQuery(
    ["PackageDetail"],
    () => getPackageDetail(id),
    {
      enabled: !!id,
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = res.data;
          if (response) {
            const transformedItems = response?.items?.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            setInitialValues({
              name: response.name,
              price: response.price,
              numberOfVisit: response.number_of_visit,
              packageItems: transformedItems || [],
            });
          }
        }
      },
    }
  );

  if (isLoading || isFetching) {
    return <LoadingSection />;
  }

  return <DetailPackageComponent initialValues={initialValues} />;
}
